export const selfQuestionnaires = [
  {
    'no': 0,
    'title': '외인성 화합물질 내성 검사 XTT',
    'desc': '외인성 화합물질 내성 검사 XTT, Xenobiotic Tolerability Test',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '당신은 병원에서 처방 받은 약물을 복용중입니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '네. 그렇다면 얼마나 많은 약물을 복용중 입니까?', 'answerPoint': 1 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'multiple',
        'ask': '다음 약물을 복용중입니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '시메티딘(cimetidine)', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '타이레놀', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '여성호르몬제', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '이전에 병원에서 처방 받은 약물을 복용했던 경험이 있다면, 약을 복용한 다음 어떤 반응이 가장 많았습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '부작용을 경험했으며, 낮은 용량에서도 효과가 있었다', 'answerPoint': 3 },
          { 'answerNo': 1, 'answerTitle': '부작용을 경험했으며, 일반적인 용량에서도 효과가 있었다', 'answerPoint': 2 },
          { 'answerNo': 2, 'answerTitle': '부작용이 없었으며, 대개 약물의 효과도 없었다', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '부작용이 없었으며, 대개 약물도 효과가 있었다', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '최근 6개월동안 지속적으로 흡연을 해왔습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '카페인 또는 카페인을 포함한 물질(게보린, 펜잘, 초콜렛, 커피 등)에 대해 심각한 부작용을 경험한 적이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 2, 'answerTitle': '모르겠음', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '집중이 잘 안되고 혼란스러우며 집중이 잘 안 되는 상황, 피로, 나른함을 자주 경험합니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '향수나 진한 향을 맡을 때 발생하는 증상이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 2, 'answerTitle': '모르겠음', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '술을 조금만 마셔도 어려움을 느낍니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 8,
        'askType': 'multiple',
        'ask': '다음의 병력이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '환경 및 화학물질에 대한 과민반응', 'answerPoint': 5 },
          { 'answerNo': 1, 'answerTitle': '만성피로증후군', 'answerPoint': 5 },
          { 'answerNo': 2, 'answerTitle': '섬유근육통', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '파킨슨 증후군 증상', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '알코올 또는 화학물질에 대한 의존', 'answerPoint': 2 },
          { 'answerNo': 5, 'answerTitle': '알코올 또는 화학물질에 대한 의존', 'answerPoint': 1 }
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '제초제, 살충제, 유기용매 등과 같은 유해한 화학물질에 노출된 경험이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 10,
        'askType': 'single',
        'ask': '와인, 건과일, 샐러드바, 야채 등과 같이 아황산염(sulfite)을 포함한 음식을 먹었을 때 알레르기 반응이나 부작용을 경험한 적이 있습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '네', 'answerPoint': 2 },
          { 'answerNo': 1, 'answerTitle': '아니오', 'answerPoint': 0 },
          { 'answerNo': 2, 'answerTitle': '모르겠음', 'answerPoint': 0 }
        ]
      }
    ],
    'intervention': [
      'With Low ALP; Zn 보충', 'High XTT; TMA c OAA', '3~6Mo. 후 F/U', 'GSH, MegaC, kyominotin, weekly x 8'
    ],
    'resultType': 'gauge',
    'results': [
      { 'resultNo': 0, 'resultCondition': '4점 이상', 'resultTitle': '정상', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '5~9점', 'resultTitle': '주의요망', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '10점 이상', 'resultTitle': '외인성 약물 중독 높음', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 39,
    'subArcs' : [ { limit: 4 }, { limit: 9 }, { limit: 39 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#C80000' ]
  },
  {
    'no': 1,
    'title': 'Cohen Perceived Stress',
    'desc': '이 검사의 질문들은 지난 한 달 동안 당신이 어떤 일에 대해서 얼마나 자주 그렇게 느꼈는지, 어떤 생각을 했는지에 대해 묻는 스트레스 검사입니다. 어떤 문항들은 비슷해 보이지만 각 문항마다 작은 차이점이 존재하기 때문에 각각의 문제를 독립된 문제로 인지하고 대답해야 합니다. 가장 정확한 결과를 얻기 위해서 질문을 읽고 바로바로 대답을 해주십시오.',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '1. 지난 한 달 동안, 예상치 못한 일이 생겨서 기분 나빠진 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '2. 지난 한 달 동안, 중요한 일들을 통제할 수 없다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '3. 지난 한 달 동안, 초조하거나 스트레스가 쌓인다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '4. 지난 한 달 동안, 짜증나고 성가신 일들을 성공적으로 처리한 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 4,
        'askType': 'single',
        'ask': '5. 지난 한 달 동안, 생활 속에서 일어난 중요한 변화들을 효과적으로 대처한 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 5,
        'askType': 'single',
        'ask': '6. 지난 한 달 동안, 자신에게 중요한 일을 잘 대처하지 못했다고 얼마나 자주 느꼈나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 6,
        'askType': 'single',
        'ask': '7. 지난 한 달 동안, 자신의 뜻대로 일이 진행된다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 7,
        'askType': 'single',
        'ask': '8. 지난 한 달 동안, 매사를 잘 컨트롤하고 있다고 느낀 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 4 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 3 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 1 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 0 }
        ]
      },
      {
        'askNo': 8,
        'askType': 'single',
        'ask': '9. 지난 한 달 동안, 당신이 통제할 수 없는 범위에서 발생한 일 때문에 화가난 적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      },
      {
        'askNo': 9,
        'askType': 'single',
        'ask': '10. 지난 한 달 동안, 어려운 일이 너무 많이 쌓여서 극복할 수 없다고 느낀적이 얼마나 자주 있었나요?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '절대아님', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '거의아님', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '가끔', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '대체로 그러함', 'answerPoint': 3 },
          { 'answerNo': 4, 'answerTitle': '자주 그러함', 'answerPoint': 4 }
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'results': [
      { 'resultNo': 0, 'resultCondition': '총점 13점 미만', 'resultTitle': '양호', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '총점 13~20점 미만', 'resultTitle': '평균', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 2, 'resultCondition': '총점 20점 이상', 'resultTitle': '높은 스트레스 그룹', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 40,
    'subArcs' : [ { limit: 13 }, { limit: 20 }, { limit: 40 } ],
    'colorArray' : [ '#47D9D9', '#FFBB00', '#C80000' ]
  },
  {
    'no': 2,
    'title': '과민성 방광 증상 자가 진단',
    'desc': '최근 1주일간 당신의 상태에 가장 가까운 것을 하나만 골라 답해주세요.',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '1. 아침에 일어나서 밤에 자기 전까지 몇회 정도 소변을 보셨습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '7회 이하', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '8~14회', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '15회 이상', 'answerPoint': 2 }
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '2. 밤에 잠든 후부터 아침에 일어날 때가지 소변을 보기 위해 몇 회나 일어나셨습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '0회', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '1회', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '2회', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '3회 이상', 'answerPoint': 3 }
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '3. 갑자기 소변이 마려워 참기 힘들었던 적이 있었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '없음', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '일주일에 1회보다는 적음', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '일주일에 1회 혹은 그 이상', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '일 1회 정도', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '일 1회 2~4회 정도', 'answerPoint': 4 },
          { 'answerNo': 3, 'answerTitle': '일 1회 5회 또는 그 이상', 'answerPoint': 5 }
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '4. 갑자기 소변이 마려워서 참지 못하고 소변을 지린 적이 있었습니까?',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '없음', 'answerPoint': 0 },
          { 'answerNo': 1, 'answerTitle': '일주일에 1회보다는 적음', 'answerPoint': 1 },
          { 'answerNo': 2, 'answerTitle': '일주일에 1회 혹은 그 이상', 'answerPoint': 2 },
          { 'answerNo': 3, 'answerTitle': '일 1회 정도', 'answerPoint': 3 },
          { 'answerNo': 3, 'answerTitle': '일 1회 2~4회 정도', 'answerPoint': 4 },
          { 'answerNo': 3, 'answerTitle': '일 1회 5회 또는 그 이상', 'answerPoint': 5 }
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'gauge',
    'results': [
      { 'resultNo': 0, 'resultCondition': '총점 2점 이하', 'resultTitle': '양호', 'resultIconType': 'MoodIcon' },
      { 'resultNo': 1, 'resultCondition': '총점 3점 이상', 'resultTitle': '상담', 'resultIconType': 'SentimentSatisfiedAltIcon' },
      { 'resultNo': 2, 'resultCondition': '총점 5점 이하', 'resultTitle': '경증', 'resultIconType': 'SentimentNeutralIcon' },
      { 'resultNo': 3, 'resultCondition': '총점 6~11점 이상', 'resultTitle': '중증도', 'resultIconType': 'SentimentVeryDissatisfiedIcon' },
      { 'resultNo': 4, 'resultCondition': '총점 12점 이상', 'resultTitle': '중증', 'resultIconType': 'MoodBadIcon' },
    ],
    'resultMaxPoint': 15,
    'subArcs' : [ { limit: 2 }, { limit: 4 }, { limit: 5 }, { limit: 11 }, { limit: 15 } ],
    'colorArray' : [ '#47D9D9', '#8AB904', '#FFBB00', '#FF8000', '#C80000' ]
  },
  {
    'no': 3,
    'title': '피부나이 측정',
    'desc': '',
    'questions': [
      {
        'askNo': 0,
        'askType': 'single',
        'ask': '식사는 거르지 않고 규칙적으로 한다',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 1 },
        ]
      },
      {
        'askNo': 1,
        'askType': 'single',
        'ask': '하루 3~4시간 이상 햇빛에 노출된다',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 3 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': -1 },
        ]
      },
      {
        'askNo': 2,
        'askType': 'single',
        'ask': '외출 할때는 항상 자외선 차단제를 바른다',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': -1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': 2 },
        ]
      },
      {
        'askNo': 3,
        'askType': 'single',
        'ask': '날마다 화장을 한다',
        'answer': [
          { 'answerNo': 0, 'answerTitle': '그렇다', 'answerPoint': 1 },
          { 'answerNo': 1, 'answerTitle': '아니다', 'answerPoint': -1 },
        ]
      }
    ],
    'intervention': [
    ],
    'resultType': 'simple',
    'results': [],
    'resultMaxPoint': 0,
    'subArcs' : [],
    'colorArray' : []
  },
];